var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F2F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 29V31H19V29H11C10.7348 29 10.4804 28.8946 10.2929 28.7071C10.1054 28.5196 10 28.2652 10 28V12C10 11.7348 10.1054 11.4804 10.2929 11.2929C10.4804 11.1054 10.7348 11 11 11H17C17.5676 10.9993 18.1288 11.1198 18.6461 11.3532C19.1635 11.5867 19.625 11.9279 20 12.354C20.375 11.9279 20.8365 11.5867 21.3539 11.3532C21.8712 11.1198 22.4324 10.9993 23 11H29C29.2652 11 29.5196 11.1054 29.7071 11.2929C29.8946 11.4804 30 11.7348 30 12V28C30 28.2652 29.8946 28.5196 29.7071 28.7071C29.5196 28.8946 29.2652 29 29 29H21ZM28 27V13H23C22.4696 13 21.9609 13.2107 21.5858 13.5858C21.2107 13.9609 21 14.4696 21 15V27H28ZM19 27V15C19 14.4696 18.7893 13.9609 18.4142 13.5858C18.0391 13.2107 17.5304 13 17 13H12V27H19Z",
    fill: "#4778F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompEdit);
export default __webpack_public_path__ + "static/media/compEdit.241f800cfa6debd1849039a06df12a48.svg";
export { ForwardRef as ReactComponent };